import { createAuthorizationHeader } from '@ff-os/shared-utils/private-urls';
import { urls } from '@ff-os/shared-utils/urls';
import { PdpState } from '../../store';
import { withAuthorization } from '../authorization/withAuthorization';
import { createAsyncAppThunk } from '../createAsyncAppThunk';
import { isProjectCompatible } from '../isProjectCompatible';
import { openProject } from '../openProject';

type LoadProjectResponse = {
    design: string;
    version: number;
    savedOn: number;
};

export const loadProject = createAsyncAppThunk<{ onSuccess: () => void }, void>(
    'projects/load',
    async ({ onSuccess }, thunkApi) => {

        const response = await withAuthorization(async (state: PdpState) => {
            return fetch(urls.openProject, formatRequest(state));
        }, thunkApi);

        if (!response.ok) {
            throw new Error(`Load project error: ${urls.openProject} [${response.status}]`);
        }

        const state = thunkApi.getState();
        const project = await response.json() as LoadProjectResponse;

        const isCompatible = isProjectCompatible(
            state.compatibility.sceneVersion, project.version);

        const result = await openProject(thunkApi, state.scene.pluginId, project, isCompatible, 'remote');

        if (result.continue) {
            onSuccess();
        }
    });

const formatRequest = (state: PdpState) => ({
    method: 'GET',
    mode: 'cors' as RequestMode,
    headers: createAuthorizationHeader(state.auth.jwt!)
});